import React, {useEffect, useMemo, useRef, useState} from "react";
import {Badge, Button, Col, Modal, Row, Spinner, Stack} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {
    fetchAdvancedTypesSales,
    fetchBankAccounts, fetchCashRegisters,
    fetchClients,
    fetchPOS,
    fetchSalesGeneralSettings,
    sendInvoiceToMyData,
} from "../../../../_apis/api";
import EditableTable from "../../../primer/Editable-Table";
import {useSelector} from "react-redux";
import {
    getCountryOptions,
    getCurrentUser,
    getDefaultOptionByValue,
    getGreekCurrencyFormat,
    getOptionsByData,
    getSalesPrintData,
    isEmpty,
    removeDuplicateObjects,
    salesMyDataStatus,
} from "../../../../_helpers/commonFunctions";
import {
    fixDocumentTaxesDisplay,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {
    setEditSales,
    setViewSalePeppolEdit, setViewSalePeppolEditOldData
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {toast} from "react-toastify";
import getMyData, {getSpecialCategoryOptions, reverseDeliveryNotePurposes} from "../../../../_helpers/sharedmydata";
import axios from "axios";
import SendEmail from "../../../primer/POPUP-COMPONENTS/Send-Email";
import {getSalesTotals} from "../../../../_helpers/product-sales-calculations";
import SalesPrintTemplateGreek1 from "../../PrintLayout/sales-print-template1-greek";
import {loadingAddressOptions, salesLocationData} from "../../../../_data/sales/sales-payment-types";
import SalesPrintA5Greek from "../../PrintLayout/sales-print-a5-greek";
import SalesPrintA5DoubleGreek from "../../PrintLayout/sales-print-a5-double-greek";
import SalesPrintTemplateEnglish1 from "../../PrintLayout/sales-print-template1-english";
import SalesPrintA5English from "../../PrintLayout/sales-print-a5-english";
import SalesPrintA5DoubleEnglish from "../../PrintLayout/sales-print-a5-double-english";
import Alert from "react-bootstrap/Alert";
import SendPayment from "../../../primer/POPUP-COMPONENTS/SendPayment/SendPayment";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {AccountingView} from "../../../primer/AccountingView/AccountingView";
import moment from "moment";
import {Popover} from "antd";
import SelectAnathetousaModal from "../../../primer/POPUP-COMPONENTS/SelectAnathetousaModal";
import AccountingBox from "../../../primer/AccountingBox";
import LogTable from "../../../primer/LogTable";
import {isDeliveryNoteTypes} from "../../../../_data/mydata/isDeliveryNoteTypes";
import DateTimeBox from "../../../primer/DateTimeBox";
import CloudHooksModal from "../Cloud/Modal Components/CloudHooksModal";
import ThermalPrint55 from "../../PrintLayout/thermal-print-55mm";
import ThermalPrint80 from "../../PrintLayout/thermal-print-80mm";
import ThermalPrint110 from "../../PrintLayout/thermal-print-110mm";
import {getOtherCorrelatedEntitiesTypes} from "../../../../_data/mydata/otherCorrelatedEntities";
import {DoyOptions} from "../../../../_data/clients/doy-options";
import {openClientPayment, openDCLLocal, openQuotation} from "../../../../_helpers/tabOpeners";
import useTaggedDispatch from "../../../../hooks/useTaggedDispatch";
import {FaFileInvoice} from "react-icons/fa";
import PackingsDeclarations from "../../../primer/POPUP-COMPONENTS/PackingsDeclarations/PackingsDeclarations";
import SalesViewTransfer from "./Transfers/SalesViewTransfer";
import {useTranslation} from "../../../../hooks/useTranslation";

const ViewSales = ({tabKey = "0"}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({ tabKey });
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const CASH_DATA = useSelector((state) => state.CASH_DATA);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const printLayout = useSelector((state) => state.SALES.printLayout);

    const editSales = useSelector((state) => state.SALES.editSales[tabKey]);
    const viewSalePeppolEdit = useSelector((state) => state.SALES.viewSalePeppolEdit[tabKey]);
    const viewSalePeppolEditOldData = useSelector((state) => state.SALES.viewSalePeppolEditOldData[tabKey]);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const SETTINGS = useSelector((state) => state.SETTINGS);

    const requestData = {
        company: company.id,
        year: company.year.toString(),
    }
    const currentUser = getCurrentUser();
    const requestData2 = {
        company: company.id,
        year: company.year.toString(),
        isActive: "active",
        userId: currentUser.id
    }

    const productCodeColumns = [
        {
            label: t('SalesNewView.productCodeTable.code'),
            name: "code",
        },
        {
            label: t('SalesNewView.productCodeTable.productName'),
            name: "name",
        },
        {
            label: t('SalesNewView.productCodeTable.alternativeName'),
            name: "alternateName",
        },
    ];
    const [activeTab, setActiveTab] = useState(0);
    const [showMyDataErrorModal, setShowMyDataErrorModal] = useState(false);
    const [loadingSendToMyData, setLoadingSendToMyData] = useState(false);
    const [showLinkedClientPayments, setShowLinkedClientPayments] = useState(false);
    const canHaveOtherCorrelations = !isEmpty(editSales.myDataType) && editSales.myDataType !== "1.6" && editSales.myDataType !== "2.4" && editSales.myDataType !== "5.1";

    const countryOptions = [{label: "Κενό", value: ""}, ...getCountryOptions("all")];

    useEffect(() => {
        if (editSales.enablePeppol === "active" && viewSalePeppolEdit === true) {
            cancelPeppolEdit();
        }
        dispatch(fetchClients(requestData));
        dispatch(fetchAdvancedTypesSales(requestData));
        dispatch(fetchSalesGeneralSettings(requestData2))
        dispatch(fetchPOS(requestData2));
        dispatch(fetchBankAccounts(requestData2));
        dispatch(fetchCashRegisters(requestData2));

        if (editSales.corelatedDocument && isEmpty(editSales.corelatedDocumentName)) {
            axios.post(process.env.REACT_APP_API_URL2 + "/sale/get-correlated-name", {
                company: company.id,
                saleId: editSales.corelatedDocument
            }, {
                headers: {'Content-Type': 'application/json'}
            }).then((res) => {
                if (res.data.status === "200") {
                    dispatch(setEditSales({...editSales, corelatedDocumentName: res.data.data}));
                }
                if (editSales.enablePeppol === "active") {
                    getPeppolStatus();
                }
            }).catch((err) => {
                console.log(err);
            })
        } else if (editSales.enablePeppol === "active") {
            getPeppolStatus();
        }
    }, []);

    // Options for Document Type Dropdown
    let pMDDSettings = SETTINGS.primerMyDataData;
    const COMPANY_DATA = useSelector((state) => state.COMPANY_DATA);
    const waysOfSendingGoodsOptions = [{value: "", label: t("Null")}, ...getOptionsByData(SALES_SETTINGS.salesGeneralSettings.sendingGoods, "_id", "name")];
    const carNumbersOptions = [{value: "", label: t("Null")}, ...getOptionsByData(SALES_SETTINGS.salesGeneralSettings.carNumbers, "_id", "number")];
    let otherTaxesOptions = useMemo(() => getOptionsByData(pMDDSettings?.otherTaxes !== undefined && pMDDSettings?.otherTaxes !== '' ? pMDDSettings.otherTaxes.filter(otherTax => otherTax.taxLevel === 1) : SETTINGS.otherHoldTaxes, 'code', 'name'), [pMDDSettings, SETTINGS.otherHoldTaxes]);
    let withHoldTaxesOptions = useMemo(() => getOptionsByData(pMDDSettings?.withHoldTaxes !== undefined && pMDDSettings?.withHoldTaxes !== '' ? pMDDSettings.withHoldTaxes.filter(withHoldTax => withHoldTax.taxLevel === 1) : SETTINGS.withHoldTaxes, 'code', 'name'), [pMDDSettings, SETTINGS.withHoldTaxes]);
    let stampOptions = useMemo(() => getOptionsByData(pMDDSettings?.stamp !== undefined && pMDDSettings?.stamp !== '' ? pMDDSettings.stamp.filter(stamp => stamp.taxLevel === 1) : SETTINGS.stamp, 'code', 'name'), [pMDDSettings, SETTINGS.stamp]);
    let feesOptions = useMemo(() => getOptionsByData(pMDDSettings?.fees !== undefined && pMDDSettings?.fees !== '' ? pMDDSettings.fees.filter(fee => fee.taxLevel === 1) : SETTINGS.fees, 'code', 'name'), [pMDDSettings, SETTINGS.fees]);
    otherTaxesOptions = [{value: "", label: t("Null"), color: "#76AEB7"}, ...otherTaxesOptions]
    withHoldTaxesOptions = [{value: "", label: t("Null"), color: "#76AEB7"}, ...withHoldTaxesOptions]
    stampOptions = [{value: "", label: t("Null"), color: "#76AEB7"}, ...stampOptions]
    feesOptions = [{value: "", label: t("Null"), color: "#76AEB7"}, ...feesOptions]
    const salesPurposeOptions = getMyData({type: 'salePurpose', settings: SETTINGS});
    const salesMyDataStatusOptions = salesMyDataStatus();
    const specialInvoiceCategoryOptions = getSpecialCategoryOptions("");
    const myDataStatusDefault = getDefaultOptionByValue(salesMyDataStatusOptions, editSales.myDataStatus ? editSales.myDataStatus : 'not_sent', 'value', 'label', 'value');

    let selectedDocumentTypeData = [];
    let dtInstallationsOptions = [];
    let printTemplateData = getSalesPrintData("editSales", editSales, COMPANY_DATA, SETTINGS, printLayout);
    const componentRef = useRef(null);
    const componentRefA5 = useRef(null);
    const componentRefA5En = useRef(null);
    const componentRefDA5 = useRef(null);
    const componentRefDA5En = useRef(null);
    const componentRefEn = useRef(null);
    const componentRefT50 = useRef(null);
    const componentRefT80 = useRef(null);
    const componentRefT110 = useRef(null);

    let disabledFields = false;
    if (editSales.documentType === undefined || editSales.documentType === '') {
        disabledFields = true;
    } else {
        let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, editSales.documentType, '_id');
        if (dtData.length > 0) {
            selectedDocumentTypeData = dtData['0'];
            dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
            dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
        }
    }
    useEffect(() => {
        printTemplateData = getSalesPrintData("editSales", editSales, COMPANY_DATA, SETTINGS, printLayout);
    }, [printLayout])

    const clientProductsColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "50px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNewView.productTable.code'),
            field: "code",
            width: "120px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: [],
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('ProductsListNew.table.placeholderCode')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('SalesNewView.productTable.name'),
            field: "name",
            width: "400px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: [],
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('ProductsListNew.table.placeholderName')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('SalesNewView.productTable.quantity'),
            field: "quantity",
            width: "90px",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    maxLength: 10 // Given in the wireframe
                }
            }
        },
        {
            name: t('SalesNewView.productTable.mu'),
            field: "muLabel",
            editable: false,
            width: "60px",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNewView.productTable.unitPrice'),
            field: "unitPrice",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "130px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10,
                }
            }
        },
        {
            name: t('SalesNewView.productTable.discount'),
            field: "discount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            width: "80px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: "%",
            field: "isPerDiscount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                name: 'discountType',
                radioLogic: 'oneperrow',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: "€",
            field: "isDiscountAmount",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                radioLogic: 'oneperrow',
                name: 'discountType',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: t('SalesNewView.productTable.vat'),
            field: "vatPercentage",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNewView.productTable.netValue'),
            field: "netValue",
            editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.vatValue'),
            field: "vat",
            width: "90px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNewView.productTable.taxes'),
            field: "taxes",
            editable: false,
            width: "90px",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNewView.productTable.totalValue'),
            field: "totalValue",
            editable: false,
            width: "150px",
            inputType: {
                otherInfo: "view-sales-totalValue",
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
    ]

    const otherCorrelatedInvoicesTableColumns = [
        {
            name: "Παραστατικό",
            field: "docInfo",
            width: "40%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "MARK",
            field: "docMark",
            width: "30%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Επιπλέον πληροφορίες",
            field: "docNotes",
            width: "30%",
            inputType: {
                type: 'text',
            }
        },
    ]

    const sendToMyData = () => {
        let data = {
            companyId: company.id,
            year: company.year.toString(),
            saleId: editSales._id
        }
        dispatch(sendInvoiceToMyData(data, null, setLoadingSendToMyData));
    }

    const openCorrelatedDcl = () => {
        let reqData = {company: company.id, id: editSales?.correlatedDclObj};
        axios.post(process.env.REACT_APP_API_URL2 + `/dcl/fetch-dcl-by-id`, reqData, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    dispatch(openDCLLocal(res.data.data, TABS_DATA));
                } else {
                    toast.error("Η συσχετιζόμενη εγγραφή δεν βρέθηκε!");
                }
            } else {
                toast.error("Η συσχετιζόμενη εγγραφή δεν βρέθηκε!");
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const handleExtraFieldToggle = (fieldName, isChecked) => {
        const currentExtraData = Array.isArray(editSales?.extraData) && editSales.extraData.length > 0
            ? { ...editSales.extraData[0] }
            : { ...(editSales?.extraData || {}) };

        let updatedRegime4200 = currentExtraData.isRegime4200 !== undefined ? String(currentExtraData.isRegime4200) : "false";
        let updatedTriangular = currentExtraData.isTriangularTrade !== undefined ? String(currentExtraData.isTriangularTrade) : "false";

        if (fieldName === "isRegime4200") {
            updatedRegime4200 = isChecked ? "true" : "false";
            if (isChecked) updatedTriangular = "false";
        } else if (fieldName === "isTriangularTrade") {
            updatedTriangular = isChecked ? "true" : "false";
            if (isChecked) updatedRegime4200 = "false";
        }

        const updatedExtraDataObj = {
            ...currentExtraData,
            isRegime4200: updatedRegime4200,
            isTriangularTrade: updatedTriangular,
        };

        const updatedSaleObj = {
            ...editSales,
            extraData: Array.isArray(editSales?.extraData) ? [updatedExtraDataObj] : updatedExtraDataObj,
        };

        dispatch(setEditSales(updatedSaleObj));
        axios.post(process.env.REACT_APP_API_URL2 + "/sale/update-sale-extra-fields", {
            company: company.id,
            saleId: editSales._id,
            isRegime4200: updatedRegime4200,
            isTriangularTrade: updatedTriangular,
        }, {
            headers: { "Content-Type": "application/json" }
        }).then((res) => {
            if (res.data?.status === "200") {
                toast.success("Τα επιπλέον στοιχεία ενημερώθηκαν επιτυχώς.");
            } else {
                toast.error(res.data?.message || "Σφάλμα κατά την αποθήκευση.");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Σφάλμα επικοινωνίας με τον διακομιστή.");
        });
    };

    const notEditableFields = true;

    const salesProductListActions = {
        insert: () => {
        },
        update: () => {
        },
        selected: () => {
        },
        delete: () => {
        }
    }
    let tableWrClasses = "product-form sales-products-list position-relative disabled-page";
    if (editSales.client !== '') {
        tableWrClasses += " normalIndex";
    }

    let cashRegistersData = CASH_DATA.cashRegisters;
    let cashRegisterOptions = [{
        value: "",
        label: t("General.empty")
    }, ...getOptionsByData(cashRegistersData, "_id", "name")];

    const editSalesTab = [
        {
            tabName: t('SalesNewView.productTable.title'),
            tabData: (editSales.extraData.length > 0 && (
                    <React.Fragment>
                        <Row className={tableWrClasses} style={{pointerEvents: "none"}}>
                            <Col md={12}>
                                {(editSales.client === '' && editSales.newClient === '') &&
                                    <div className="overlay_w">{t('SalesNewView.message2')}</div>}
                                {editSales?.products && editSales?.products?.length === 0 &&
                                    <span className="text-danger">{t('SalesNewView.messageProductList')}</span>}
                                <EditableTable
                                    tableName="Sales Products List"
                                    key={"Sales Products List"}
                                    actionButtons={{
                                        print: false,
                                        delete: false,
                                        export: false,
                                        edit: true,
                                    }}
                                    columns={clientProductsColumns}
                                    data={editSales.products}
                                    allowInsertRow={false}
                                    onUpdate={salesProductListActions}
                                    allowActions={true}
                                    allowToggleColumns={false}
                                    allowPrintResults={false}
                                />
                            </Col>
                        </Row>
                        {editSales?.discountAsLine === true && (
                            <Row>
                                <Col md={12} className={"d-flex justify-content-end"}>
                                    <div className={"mt-1 mr-3 text-muted"}>(*) Η έκπτωση θα προβληθεί ως γραμμή
                                        παραστατικού με περιγραφή: {editSales?.discountAsLineText}</div>
                                </Col>
                            </Row>
                        )}
                    </React.Fragment>
                )
            ),
        },
        {
            tabName: t('SalesNewView.extraDataTable.title'),
            tabData: (
                <>
                    <Row className="disabled-page">
                        <Col sm={12} md={3} className="mb-2">
                            {editSales.myDataType !== "2.1" && editSales.myDataType !== "2.2" && editSales.myDataType !== "2.3" && editSales.myDataType !== "2.4" && editSales.myDataType !== "11.2" && editSales.myDataType !== "7.1" && editSales.myDataType !== "8.1" && editSales.myDataType !== "8.2" && (
                                <Dropdown
                                    label={t('SalesNewView.extraDataTable.locationDelivery')}
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(salesLocationData, editSales?.extraData[0]?.deliveryLocation, 'value', 'label', 'value')}
                                    name="deliveryLocation"
                                    options={salesLocationData}
                                    disabled={true}
                                />
                            )}
                        </Col>
                        {editSales?.extraData[0]?.deliveryLocation === "custom" && (
                            <Row className="border-bottom mb-2">
                                <Col sm={12} md={3} className="mb-2">
                                    <Dropdown
                                        label={t('SalesNewView.extraDataTable.locationCountry.locationCountry')}
                                        key={Math.random()}
                                        defaultValue={getDefaultOptionByValue(countryOptions, editSales.extraData[0].locationCountry, 'value', 'label', 'value')}
                                        name="locationCountry"
                                        required={true}
                                        options={countryOptions}
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm={12} md={3} className="mb-2">
                                    <Input
                                        label={t('SalesNewView.extraDataTable.locationCity.locationCity')}
                                        value={editSales.extraData[0].locationCity}
                                        name="locationCity"
                                        type="text"
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm={12} md={3} className="mb-2">
                                    <Input
                                        label={t('SalesNewView.extraDataTable.locationAddress.locationAddress')}
                                        value={editSales.extraData[0].locationAddress}
                                        name="locationAddress"
                                        type="text"
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm={12} md={3} className="mb-2">
                                    <Input
                                        label={t('SalesNewView.extraDataTable.locationPostalCode.locationPostalCode')}
                                        type="text"
                                        value={editSales.extraData[0].locationZip}
                                        name="locationZip"
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Input
                                        label={"Α.Φ.Μ. Παραλήπτη"}
                                        type={"text"}
                                        value={editSales.extraData[0]?.locationVatNumber}
                                        name={"locationVatNumber"}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Input
                                        label={"Ονομασία Εταιρείας Παράδοσης"}
                                        type={"text"}
                                        value={editSales.extraData[0]?.locationCompanyName}
                                        name={"locationCompanyName"}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Col sm={12} md={3} className="mb-2">
                            <Dropdown
                                label={t('SalesNewView.extraDataTable.wayOfSendingGoods')}
                                className="mb-2 w-100"
                                name="wayOfSendingGoods"
                                options={waysOfSendingGoodsOptions}
                                key={Math.random()}
                                defaultValue={getDefaultOptionByValue(waysOfSendingGoodsOptions, editSales.extraData[0].wayOfSendingGoods, 'value', 'label', 'value')}
                                disabled={true}
                            />
                        </Col>
                        {editSales.extraData[0].deliveryLocation === "custom" && (
                            <Col></Col>
                        )}
                        <Col sm={12} md={3} className="mb-2">
                            {editSales.extraData[0]?.otherTaxAsLine === "true" ? (
                                <Row>
                                    <Col md={7}>
                                        <Dropdown
                                            label={t('SalesNewView.extraDataTable.otherTaxes')}
                                            key={Math.random()}
                                            defaultValue={getDefaultOptionByValue(otherTaxesOptions, editSales.extraData[0].otherTax, 'value', 'label', 'value')}
                                            name="otherTax"
                                            options={otherTaxesOptions}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={5}>
                                        <label>{"Ποσό λοιπόν φόρων"}</label>
                                        <AccountingBox
                                            name={"otherTaxEuro"}
                                            defaultValue={editSales.extraData[0].otherTaxEuro}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <BetterCheckBox
                                            name={"otherTaxAsLine"}
                                            text={"Προβολή ως γραμμή παραστατικού"}
                                            checked={editSales.extraData[0]?.otherTaxAsLine === "true"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Input
                                            name={"otherTaxAsLineText"}
                                            label={"Όνομα γραμμής λοιπού φόρου"}
                                            value={isEmpty(editSales.extraData[0]?.otherTaxAsLineText) ? "" : editSales.extraData[0]?.otherTaxAsLineText}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <Dropdown
                                    label={t('SalesNewView.extraDataTable.otherTaxes')}
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(otherTaxesOptions, editSales.extraData[0].otherTax, 'value', 'label', 'value')}
                                    name="otherTax"
                                    options={otherTaxesOptions}
                                    disabled={true}
                                />
                            )}
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            {editSales.extraData[0]?.withHoldTaxAsLine === "true" ? (
                                <Row>
                                    <Col md={7}>
                                        <Dropdown
                                            label={t('SalesNewView.extraDataTable.withHoldTaxes')}
                                            key={Math.random()}
                                            defaultValue={getDefaultOptionByValue(withHoldTaxesOptions, editSales.extraData[0].withHoldTax, 'value', 'label', 'value')}
                                            name="withHoldTax"
                                            options={withHoldTaxesOptions}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={5}>
                                        <label>{"Ποσό παρακράτησης"}</label>
                                        <AccountingBox
                                            name={"witholdTaxEuro"}
                                            defaultValue={editSales.extraData[0]?.withHoldTaxEuro}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <BetterCheckBox
                                            name={"withHoldTaxAsLine"}
                                            text={"Προβολή ως γραμμή παραστατικού"}
                                            checked={editSales.extraData[0]?.withHoldTaxAsLine === "true"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Input
                                            name={"withHoldTaxAsLineText"}
                                            label={"Όνομα γραμμής παρακρατούμενου"}
                                            value={isEmpty(editSales.extraData[0]?.withHoldTaxAsLineText) ? "" : editSales.extraData[0]?.withHoldTaxAsLineText}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <Dropdown
                                    label={t('SalesNewView.extraDataTable.withHoldTaxes')}
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(withHoldTaxesOptions, editSales.extraData[0].withHoldTax, 'value', 'label', 'value')}
                                    name="withHoldTax"
                                    options={withHoldTaxesOptions}
                                    disabled={true}
                                />
                            )}
                        </Col>
                    </Row>
                    <Row className="disabled-page">
                        <Col sm={12} md={3}>
                            <DateTimeBox
                                classes="w-100 mb-2"
                                label={t('SalesNewView.extraDataTable.goodsSendDate')}
                                name="goodsSendDate"
                                minDate={moment().toDate()}
                                selected={moment(editSales.extraData[0].goodsSendDate).isValid() ? moment(editSales.extraData[0].goodsSendDate).toDate() : null}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            <Dropdown
                                label={t('SalesNewView.extraDataTable.carNumber')}
                                key={Math.random()}
                                defaultValue={getDefaultOptionByValue(carNumbersOptions, editSales.extraData[0].carNumber, 'value', 'label', 'value')}
                                name="carNumber"
                                options={carNumbersOptions}
                                disabled={true}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            {editSales.extraData[0]?.feeAsLine === "true" ? (
                                <Row>
                                    <Col md={7}>
                                        <Dropdown
                                            label={t('SalesNewView.extraDataTable.fees')}
                                            key={Math.random()}
                                            defaultValue={getDefaultOptionByValue(feesOptions, editSales.extraData[0].fee, 'value', 'label', 'value')}
                                            name="fee"
                                            options={feesOptions}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={5}>
                                        <label>{"Ποσό Τέλους"}</label>
                                        <AccountingBox
                                            name={"feeEuro"}
                                            defaultValue={editSales.extraData[0]?.feeEuro}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <BetterCheckBox
                                            name={"feeAsLine"}
                                            text={"Προβολή ως γραμμή παραστατικού"}
                                            checked={editSales.extraData[0]?.feeAsLine === "true"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Input
                                            name={"feeAsLineText"}
                                            label={"Όνομα γραμμής τέλους"}
                                            value={isEmpty(editSales.extraData[0]?.feeAsLineText) ? "" : editSales.extraData[0]?.feeAsLineText}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <Dropdown
                                    label={t('SalesNewView.extraDataTable.fees')}
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(feesOptions, editSales.extraData[0].fee, 'value', 'label', 'value')}
                                    name="fee"
                                    options={feesOptions}
                                    disabled={true}
                                />
                            )}
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            {editSales.extraData[0]?.stampAsLine === "true" ? (
                                <Row>
                                    <Col md={7}>
                                        <Dropdown
                                            label={t('SalesNewView.extraDataTable.stampDuty')}
                                            key={Math.random()}
                                            defaultValue={getDefaultOptionByValue(stampOptions, editSales.extraData[0].stamp, 'value', 'label', 'value')}
                                            name="stamp"
                                            options={stampOptions}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={5}>
                                        <label>{"Ποσό χαρτοσήμου"}</label>
                                        <AccountingBox
                                            name={"stampEuro"}
                                            defaultValue={editSales.extraData[0]?.stampEuro}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <BetterCheckBox
                                            name={"stampAsLine"}
                                            text={"Προβολή ως γραμμή παραστατικού"}
                                            checked={editSales.extraData[0]?.stampAsLine === "true"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Input
                                            name={"stampAsLineText"}
                                            label={"Όνομα γραμμής χαρτοσήμου"}
                                            value={isEmpty(editSales.extraData[0]?.stampAsLineText) ? "" : editSales.extraData[0]?.stampAsLineText}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <Dropdown
                                    label={t('SalesNewView.extraDataTable.stampDuty')}
                                    key={Math.random()}
                                    defaultValue={getDefaultOptionByValue(stampOptions, editSales.extraData[0].stamp, 'value', 'label', 'value')}
                                    name="stamp"
                                    options={stampOptions}
                                    disabled={true}
                                />
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <Dropdown
                                name={"cashRegister"}
                                label={t("General.cashRegister")}
                                key={Math.random()}
                                defaultValue={cashRegisterOptions.find((el) => el.value === editSales.extraData[0]?.cashRegister) ? cashRegisterOptions.find((el) => el.value === editSales.extraData[0]?.cashRegister) : ""}
                                options={cashRegisterOptions}
                                disabled={true}
                            />
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                name={"specialInvoiceCategory"}
                                label={"Ειδική Κατηγορία Παραστατικού"}
                                key={Math.random()}
                                defaultValue={specialInvoiceCategoryOptions.find((el) => el.value === editSales.specialInvoiceCategory) ? specialInvoiceCategoryOptions.find((el) => el.value === editSales.specialInvoiceCategory) : ""}
                                options={specialInvoiceCategoryOptions}
                                disabled={true}
                            />
                        </Col>
                        <Col md={3}>
                            <label>{"Ποσό κρατήσεων"}</label>
                            <AccountingBox
                                name={"deductionsEuro"}
                                disabled={true}
                                defaultValue={editSales.extraData[0].deductionsEuro}
                            />
                            {editSales.extraData[0].deductionsEuro && parseFloat(editSales.extraData[0].deductionsEuro) > 0 && (
                                <React.Fragment>
                                    <BetterCheckBox
                                        name={"deductionsAsLine"}
                                        text={"Προβολή ως γραμμή παραστατικού"}
                                        disabled={true}
                                        checked={editSales.extraData[0]?.deductionsAsLine === "true"}
                                    />
                                    {editSales.extraData[0]?.deductionsAsLine === "true" && (
                                        <Input
                                            name={"deductionsAsLineText"}
                                            label={"Όνομα γραμμής κράτησης"}
                                            disabled={true}
                                            value={isEmpty(editSales.extraData[0]?.deductionsAsLineText) ? "" : editSales.extraData[0]?.deductionsAsLineText}
                                        />
                                    )}
                                </React.Fragment>
                            )}
                        </Col>
                        {editSales?.reverseDeliveryNotePurpose && (
                            <Col md={3}>
                                <Dropdown
                                    name={"reverseDeliveryNotePurpose"}
                                    label={"Αιτία Αντίστροφης Διακίνησης"}
                                    options={reverseDeliveryNotePurposes}
                                    defaultValue={reverseDeliveryNotePurposes.find((el) => el.value === editSales.reverseDeliveryNotePurpose)}
                                    key={editSales.reverseDeliveryNotePurpose}
                                    disabled={true}
                                />
                            </Col>
                        )}
                    </Row>
                    {["1.2", "5.1", "5.2"].includes(editSales?.myDataType) && (
                        <Row className="mb-3">
                            <Col sm={12} md={4}>
                                <BetterCheckBox
                                    name={"isRegime4200"}
                                    text={"Υπόκειται στο καθεστώς 4200 (Έντυπο Φ4)"}
                                    checked={
                                        (Array.isArray(editSales?.extraData)
                                            ? editSales?.extraData[0]?.isRegime4200
                                            : editSales?.extraData?.isRegime4200) === "true"
                                    }
                                    disabled={false}
                                    onChange={(e) => handleExtraFieldToggle("isRegime4200", e.target.checked)}
                                />
                            </Col>
                            <Col sm={12} md={4}>
                                <BetterCheckBox
                                    name={"isTriangularTrade"}
                                    text={"Αφορά τριγωνική συναλλαγή (Έντυπο Φ4)"}
                                    checked={
                                        (Array.isArray(editSales?.extraData)
                                            ? editSales?.extraData[0]?.isTriangularTrade
                                            : editSales?.extraData?.isTriangularTrade) === "true"
                                    }
                                    disabled={false}
                                    onChange={(e) => handleExtraFieldToggle("isTriangularTrade", e.target.checked)}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        {editSales.specialInvoiceCategory === "4" && (
                            <React.Fragment>
                                <Col md={3}>
                                    <Input
                                        className="w-100"
                                        label={"Αριθμός Επίσημου Εγγράφου"}
                                        name={"documentIdNo"}
                                        autoComplete={"off"}
                                        value={editSales.documentIdNo}
                                        disabled={true}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        label={"Χώρα Έκδοσης Επίσημου Εγγράφου"}
                                        name={"countryDocumentId"}
                                        options={countryOptions}
                                        defaultValue={countryOptions.find((el) => el.value === editSales?.countryDocumentId) || ""}
                                        disabled={true}
                                    />
                                </Col>
                            </React.Fragment>
                        )}
                        {editSales?.fuelInvoice === "active" && (
                            <Col md={3}>
                                <Input
                                    className="w-100"
                                    label={"Αριθμός Παροχής Ηλ. Ρεύματος"}
                                    name={"supplyAccountNo"}
                                    autoComplete={"off"}
                                    value={editSales.supplyAccountNo}
                                    disabled={true}
                                />
                            </Col>
                        )}
                    </Row>
                    {((editSales?.isDeliveryNote || editSales.myDataType === "9.3") && editSales.extraData[0].loadingAddressOption) && (
                        <Row>
                            <Col md={3}>
                                <Dropdown
                                    name={"loadingAddressOption"}
                                    label={"Τοποθεσία Φόρτωσης Εμπορευμάτων"}
                                    options={loadingAddressOptions}
                                    defaultValue={loadingAddressOptions.find((el) => el.value === editSales.extraData[0].loadingAddressOption)}
                                    key={editSales.extraData[0].loadingAddressOption}
                                    disabled={true}
                                />
                            </Col>
                            {editSales.extraData[0]?.loadingAddressOption === "custom" && (
                                <React.Fragment>
                                    <Col md={3}>
                                        <Input
                                            label={"Πόλη Φόρτωσης Εμπορευμάτων"}
                                            value={editSales.extraData[0].loadingAddressCity}
                                            name="loadingAddressCity"
                                            type="text"
                                            autoComplete={"off"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Input
                                            label={"Τ.Κ. Φόρτωσης Εμπορευμάτων"}
                                            value={editSales.extraData[0].loadingAddressPostalCode}
                                            name="loadingAddressPostalCode"
                                            type="text"
                                            autoComplete={"off"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Input
                                            label={"Οδός Φόρτωσης Εμπορευμάτων"}
                                            value={editSales.extraData[0].loadingAddressStreet}
                                            name="loadingAddressStreet"
                                            type="text"
                                            autoComplete={"off"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Input
                                            label={"Αρ. Οδού Φόρτωσης Εμπορευμάτων"}
                                            value={editSales.extraData[0].loadingAddressNumber}
                                            name="loadingAddressNumber"
                                            type="text"
                                            autoComplete={"off"}
                                            disabled={true}
                                        />
                                    </Col>
                                </React.Fragment>
                            )}
                        </Row>
                    )}
                    {["9.1", "9.2", "9.3"].includes(editSales.myDataType) && (
                        <Row>
                            <Col md={4}>
                                <BetterCheckBox
                                    name={"toWeigh"}
                                    text={"Ένδειξη Δ.Α. προς ζύγιση"}
                                    checked={editSales.toWeigh}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    )}
                </>
            ),
        },
    ]

    const editCorrelatedEntitiesTab = {
        tabName: "Λοιπές Συσχετιζόμενες Οντότητες",
        tabData: (
            <React.Fragment>
                {editSales?.otherCorrelatedEntities?.length > 0 && (
                    <Row className="mt-3">
                        {editSales.otherCorrelatedEntities.map((entity, idx) => (
                            <Col md={4} className="mb-3" key={idx + "entity"}>
                                <div className={"subscription-box"}>
                                    <div style={{margin: "10px"}}>
                                        <span
                                            style={{fontWeight: "600"}}>Τύπος: </span>{getOtherCorrelatedEntitiesTypes.find((el) => String(el.value) === String(entity?.type))?.label}<br/>
                                        <span style={{fontWeight: "600"}}>Επωνυμία: </span> {entity.name}<br/>
                                        <span style={{fontWeight: "600"}}>Α.Φ.Μ.: </span> {entity.vatNumber}<br/>
                                        <span
                                            style={{fontWeight: "600"}}>Χώρα: </span> {getCountryOptions('all').find((el) => String(el.value) === String(entity?.country))?.label}<br/>
                                        {entity?.address && (<><span
                                            style={{fontWeight: "600"}}>Διεύθυνση: </span> {entity.address}, {entity.city}, {entity.postalCode}<br/></>)}
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                )}
            </React.Fragment>
        )
    }

    let posData = CASH_DATA.posList;
    let bankData = CASH_DATA.bankAccounts;
    let posOptions = getOptionsByData(posData, '_id', 'name');
    let bankOptions = getOptionsByData(bankData, '_id', 'name');
    let hidePosBankField = false;

    // This will update the list of pos / bank on type selection
    let paymentTypesData = getObjectFromArrayOfObjects(SALES_SETTINGS.salesGeneralSettings.paymentTypes, editSales.paymentType, '_id');
    if (paymentTypesData && paymentTypesData.length > 0) {
        if (paymentTypesData['0']?.type === "pos" || !isEmpty(editSales?.transactionDetails)) {
            bankOptions = posOptions;
        } else if (paymentTypesData['0']?.type === "cash" || paymentTypesData['0']?.type === "credit" || paymentTypesData['0']?.type === "cheque" || paymentTypesData['0']?.type === "iris") {
            bankOptions = [];
            hidePosBankField = true;
        }
    }

    let salesTaxesColumns = [
        {
            name: t('SalesNew.salesTaxesTables.vat%'),
            field: "vatPercentage",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.netValue'),
            field: "netValue",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.vat'),
            field: "vatEuro",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.withHoldTaxes'),
            field: "withholdTaxes",
            width: "15%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.otherTaxes'),
            field: "otherTaxes",
            width: "10%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.fees'),
            field: "fees",
            width: "10%",
            editable: false,
        },
        {
            name: t('SalesNew.salesTaxesTables.stampDuty'),
            field: "stamp",
            width: "10%",
            editable: false,
        },
        {
            name: "Κρατήσεις",
            field: "deductions",
            width: "10%",
            editable: false,
        }
    ];

    let totalTaxes = 0;
    let withHoldTaxes = 0;
    let deductions = 0;
    let productTotals = useMemo(() => getSalesTotals(editSales.products, SETTINGS), [editSales.products]);
    let salesTaxesData = editSales.salesTaxes;
    if (salesTaxesData.length > 0 && salesTaxesData[0].vatPercentage === "Invoice Level Tax") {
        totalTaxes = parseFloat((Number(salesTaxesData[0].otherTaxes) + Number(salesTaxesData[0].fees) + Number(salesTaxesData[0].stamp)).toString());
        withHoldTaxes = parseFloat(salesTaxesData[0].withholdTaxes).toFixed(2);
        deductions = parseFloat(salesTaxesData[0].deductions).toFixed(2);
    }
    let totalQuantity = productTotals.totalQuantity;
    let totalBeforeDiscount = productTotals.totalBeforeDiscount;
    let totalDiscount = productTotals.totalDiscount;
    let totalNetValue = productTotals.totalNetValue;
    let totalAmount = productTotals.totalAmount;
    let paymentAmount = productTotals.paymentAmount;
    let totalVatAmount = productTotals.totalVatValue;
    if (+totalTaxes > 0 || +withHoldTaxes > 0 || +deductions > 0) {
        totalAmount = parseFloat(totalAmount) + parseFloat(totalTaxes);
        paymentAmount = (parseFloat(paymentAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
    }
    totalTaxes += Number(productTotals.totalTaxesAmount);
    withHoldTaxes = parseFloat(productTotals.withHoldTaxes) + parseFloat(withHoldTaxes);

    const getPaymentRemainderStatus = () => {
        if (Object.keys(editSales).includes("paymentRemainder")) {
            if (editSales.paymentRemainder === editSales.paymentAmount) {
                return "unpaid"
            } else if (editSales.paymentRemainder === 0) {
                return "paid"
            } else {
                return "semipaid"
            }
        } else {
            return "unpaid"
        }
    }

    const [loadingPeppolRequest, setLoadingPeppolRequest] = useState(false);
    const [showPeppolHistory, setShowPeppolHistory] = useState(false);

    const handleOnPeppolChange = (e, type, name) => {
        let obj = {};
        if (editSales?.peppol) obj = {...editSales.peppol}
        if (type === "input") {
            obj[name] = e.target.value;
            dispatch(setEditSales({...editSales, peppol: obj}));
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                obj[name] = moment(e).format("YYYY-MM-DD")
            } else {
                obj[name] = ""
            }
            dispatch(setEditSales({...editSales, peppol: obj}));
        } else if (type === "anathetousaModal") {
            // name argument is object here from select anathetousa modal
            toast.success("Η επιλογή έγινε επιτυχώς", {autoClose: 1000});
            obj["partyIdentification"] = name.anathetousaLabelId;
            dispatch(setEditSales({...editSales, peppol: obj}));
        }
    }

    const enablePeppolEdit = () => {
        dispatch(setViewSalePeppolEdit(true));
        dispatch(setViewSalePeppolEditOldData({
            projectReference: editSales.peppol.projectReference,
            partyIdentification: editSales.peppol.partyIdentification,
            contractDocumentReference: editSales.peppol.contractDocumentReference,
            dueDate: editSales.peppol.dueDate,
        }));
    }
    const savePeppolEdit = () => {
        setLoadingPeppolRequest(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/sale/peppol-save-and-resend", {...editSales}, {
            headers: {'Content-Type': 'application/json'}
        }).then((res) => {
            setLoadingPeppolRequest(false);
            if (res.data.status === "200") {
                toast.success("Η αποστολή νέων δεδομένων έγινε επιτυχώς.");
                dispatch(setViewSalePeppolEdit(false));
                dispatch(setViewSalePeppolEditOldData({}));
                dispatch(setEditSales({...editSales, peppol: {...editSales.peppol, status: "waiting"}}))
            } else {
                toast.error(res.data.message);
            }
        }).catch((error) => {
            setLoadingPeppolRequest(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(error);
        })
    }

    const cancelPeppolEdit = () => {
        dispatch(setViewSalePeppolEdit(false));
        dispatch(setEditSales({
            ...editSales,
            peppol: {...editSales.peppol, ...viewSalePeppolEditOldData}
        }));
    }

    const [loadingPeppolStatus, setLoadingPeppolStatus] = useState(false);
    const getPeppolStatus = (showToast = false, forceRefresh = false) => {
        setLoadingPeppolStatus(true);
        axios.get(process.env.REACT_APP_API_URL2 + "/sale/get-peppol-status", {
            headers: {'Content-Type': 'application/json'},
            params: {
                company: company.id,
                mark: editSales.mark,
                forceRefresh: forceRefresh,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                if (showToast) toast.success("Η κατάσταση ανανεώθηκε.");
                dispatch(setEditSales({
                    ...editSales,
                    peppol: {...editSales.peppol, ...res.data.peppolStatus}
                }))
            } else {
                if (showToast) toast.error(res.data.message);
            }
            setLoadingPeppolStatus(false);
        }).catch((err) => {
            if (showToast) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
            setLoadingPeppolStatus(false);
        })
    }
    const [loadingCheckPeppolFields, setLoadingCheckPeppolFields] = useState(false);
    const handleCheckPeppolFields = () => {
        if (isEmpty(editSales?.vat)) {
            toast.error("Παρακαλώ επιλέξτε πελάτη.");
        } else if (isEmpty(editSales?.peppol?.projectReference) && editSales.myDataType !== "5.1") {
            toast.error("Παρακαλώ συμπληρώστε Α.Δ.Α. ή Ενάριθμο.");
        } else if (isEmpty(editSales?.peppol?.partyIdentification)) {
            toast.error("Παρακαλώ συμπληρώστε κωδικό αναθέτουσας αρχής.");
        } else {
            setLoadingCheckPeppolFields(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/sale/check-peppol-fields", {
                projectReferenceId: editSales?.peppol?.projectReference,
                buyerPartyId: editSales?.peppol?.partyIdentification,
                buyerTaxNumber: editSales?.vat,
                contractReferenceId: editSales?.peppol?.contractDocumentReference ? editSales?.peppol?.contractDocumentReference : "0",
                buyerReference: editSales?.peppol?.buyerReference ? editSales.peppol.buyerReference : "",
                company: company.id
            }, {
                headers: {'Content-Type': 'application/json'}
            }).then((res) => {
                setLoadingCheckPeppolFields(false);
                if (res.data.status === "200") {
                    toast.success("Τα πεδία είναι έγκυρα.");
                } else {
                    if (res.data.nonValidFields) {
                        let prepMessage = `Τα παρακάτω πεδία δεν είναι έγκυρα: ${res.data.nonValidFields.join(", ")}`;
                        toast.error(prepMessage, {autoClose: 7000});
                    } else {
                        toast.error(res.data.message);
                    }
                }
            }).catch((err) => {
                setLoadingCheckPeppolFields(false);
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        }
    }

    const getGreekPeppolResponseFromCode = (code) => {
        if (code === "AB") {
            return "Αναγνώριση";
        } else if (code === "IP") {
            return "Λήψη από ΙΤ";
        } else if (code === "AP") {
            return "Αποδοχή";
        } else if (code === "PD") {
            return "Πληρωμή/Μερική Πληρωμή";
        } else if (code === "UQ") {
            return "Υπό αμφισβήτηση";
        } else if (code === "RE") {
            return "Απόρριψη";
        } else {
            return code;
        }
    }

    const otherCorrelatedInvoicesTab = {
        tabName: "Συσχετιζόμενα Παραστατικά/Προεισπράξεις POS",
        tabData: (
            <React.Fragment>
                <div className="text-muted mb-2"><i>Συσχετιζόμενα Παραστατικά/Προεισπράξεις POS</i></div>
                <EditableTable
                    name={"New Sale Other Correlated Invoices"}
                    columns={otherCorrelatedInvoicesTableColumns}
                    key={"View Sales Other Correlated"}
                    data={editSales?.otherCorrelatedInvoices ? editSales?.otherCorrelatedInvoices : []}
                    allowActions={false}
                />
                {editSales.otherCorrelatedInvoices?.some((el) => el.docMyDataType === "8.4") && (
                    <span className={"text-muted"}>(*) Ο έλεγχος των ποσών των προεισπράξεων σε σχέση με το πληρωτέο ποσό, γίνεται κατά την διάρκεια της αποθήκευσης.</span>
                )}
            </React.Fragment>
        )
    }

    const packingsDeclarationsTab = {
        tabName: "Δηλώσεις Συσκευασιών",
        tabData: (
            <React.Fragment>
                <PackingsDeclarations
                    packingsDeclarations={editSales?.packingsDeclarations || []}
                    viewMode={true}
                />
            </React.Fragment>
        )
    }

    return (
        <div className="new-sales">
            <div className="client-form product-form position-relative">
                {disabledFields && <div className="overlay_w">{t('SalesNewView.message')}</div>}
                <AccountingView document={editSales}/>
                <SalesViewTransfer saleObj={editSales} />
                {(editSales.myDataStatus === "sent" || editSales?.fromMyDataReport === "true") && (
                    <Alert variant={"secondary"} className="d-flex align-items-center">
                        <div>
                            {editSales?.fromMyDataReport === "true" ? (
                                <span>Η πώληση δεν είναι επεξεργάσιμη διότι έχει προέλθει από το My Data Report.</span>
                            ) : (
                                <span>Η πώληση δεν είναι επεξεργάσιμη διότι έχει σταλεί στο My Data.</span>
                            )}
                            {editSales.mark && (
                                <React.Fragment>
                                    <br/>
                                    <span style={{fontWeight: "600"}}>MARK: </span><span>{editSales.mark}</span>
                                    <br/>
                                    <span style={{fontWeight: "600"}}>UID: </span><span>{editSales.uid}</span>
                                    {editSales.authCode && (
                                        <React.Fragment>
                                            <br/>
                                            <span
                                                style={{fontWeight: "600"}}>AUTH CODE: </span><span>{editSales.authCode}</span>
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                        {!isEmpty(editSales?.downloadingInvoiceUrl) && (
                            <div className="ms-auto">
                                <Button size={"sm"} className={"mr-1"} onClick={() => window.open(editSales.downloadingInvoiceUrl, "_blank")}>Προβολή Παραστατικού στον Πάροχο<FaFileInvoice size={18} className={"ml-1"} /></Button>
                            </div>
                        )}
                    </Alert>
                )}
                {(editSales?.cancellationMark && editSales.myDataStatus !== "sent") && (
                    <Alert variant={"secondary"}>
                        Η πώληση δεν είναι επεξεργάσιμη διότι έχει ακυρωθεί από το MyData.
                        <br/>
                        <span
                            style={{fontWeight: "600"}}>ΜΑΡΚ Ακύρωσης: </span><span>{editSales.cancellationMark}</span>
                    </Alert>
                )}
                <Row className="border-bottom mb-2 disabled-page">
                    <Col sm={12} md={4} className="showWithOverlay">
                        <Input
                            className="mb-2 w-100"
                            label={t('SalesNewView.DocumentType')}
                            name="documentType"
                            value={editSales.documentTypeName}
                            disabled={notEditableFields}
                        />
                    </Col>
                    {isDeliveryNoteTypes.includes(editSales.myDataType) ? (
                        <Col md={2} style={{paddingTop: "33px"}}>
                            <BetterCheckBox
                                name={"isDeliveryNote"}
                                checked={(editSales.isDeliveryNote !== null) ? editSales.isDeliveryNote : true}
                                required={false}
                                disabled={true}
                                text={"Αποτελεί δελτίο αποστολής"}
                            />
                        </Col>
                    ) : (
                        <Col md={2}></Col>
                    )}
                    <Col sm={12} md={6}>
                        <div className="d-flex justify-content-end">
                            <SendPayment
                                posData={posData}
                                posOptions={getOptionsByData(posData, '_id', 'name')}
                                bankOptions={getOptionsByData(bankData, '_id', 'name')}
                                paymentTypes={SALES_SETTINGS.salesGeneralSettings.paymentTypes}
                                editSales={editSales}
                                setEditSales={(saleObject) => {
                                    dispatch(setEditSales(saleObject));
                                }}
                                printRef={componentRef}
                            />
                            <CloudHooksModal
                                documentId={editSales._id}
                                section={"Sales"}
                                className={"mr-2 mt-2"}
                            />
                            <div className="mydata-status">
                                <Dropdown
                                    label={t('SalesNewView.myDataStatus')}
                                    key={Math.random()}
                                    disabled={true}
                                    options={salesMyDataStatusOptions}
                                    defaultValue={myDataStatusDefault}
                                    name="myDataStatus"
                                />
                                <div className="mb-2" style={{textAlign: "center"}}>
                                    {getPaymentRemainderStatus() === "unpaid" && (
                                        <Badge className="mb-1" bg="primary">Μη Εξοφλημένη</Badge>
                                    )}
                                    {getPaymentRemainderStatus() === "paid" && (
                                        <Badge className="mb-1" bg="primary"
                                               style={{cursor: "pointer", pointerEvents: "auto"}}
                                               onClick={() => setShowLinkedClientPayments(!showLinkedClientPayments)}>
                                            Εξοφλημένη <strong>{showLinkedClientPayments ? "-" : "+"}</strong></Badge>
                                    )}
                                    {getPaymentRemainderStatus() === "semipaid" && (
                                        <Badge className="mb-1" bg="primary"
                                               style={{cursor: "pointer", pointerEvents: "auto"}}
                                               onClick={() => setShowLinkedClientPayments(!showLinkedClientPayments)}>
                                            Μερικώς Εξοφλημένη.
                                            Υπόλοιπο: {String(Number(editSales?.paymentRemainder).toFixed(2)).replace(".", ",")} € <strong>{showLinkedClientPayments ? "-" : "+"}</strong>
                                        </Badge>
                                    )}
                                    {getPaymentRemainderStatus() !== "unpaid" && showLinkedClientPayments && (
                                        <Stack gap={1} key={"cpStack"}>
                                            {!editSales.creditDocument && editSales?.linkedClientPayments && editSales?.linkedClientPayments?.length > 0 && editSales.linkedClientPayments.map((cp, i) => (
                                                <Badge key={i} bg="primary"
                                                       style={{cursor: "pointer", pointerEvents: "auto"}}
                                                       onClick={() => openClientPayment(dispatch, TABS_DATA, company.id, cp.clientPaymentId)}>
                                                    Από την
                                                    είσπραξη {cp.displayString} : {String(Number(cp.amount).toFixed(2)).replace(".", ",")} €</Badge>
                                            ))}
                                            {editSales.creditDocument && (
                                                <Badge bg="primary" key={editSales.creditDocument}>Λόγω έκδοσης
                                                    πιστωτικού</Badge>
                                            )}
                                            {editSales.canBePaidOff === "inactive" && (
                                                <Badge bg="primary" key={editSales.creditDocument}>Λόγω ρύθμισης
                                                    του γενικού παραστατικού</Badge>
                                            )}
                                        </Stack>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="3">
                        {/* If "MyData rules" is enabled in "Settings-Document Types-Advanced Types", then FIELD IS READ ONLY. Select current date only. */}
                        <div className="d-flex disabled-page">
                            <DateBox
                                classes="w-100 mb-2"
                                label={t('SalesNewView.Date')}
                                name="date"
                                selected={moment(editSales.date).isValid() ? moment(editSales.date).toDate() : ""}
                                readOnly={true}
                                disabled={notEditableFields}
                            />
                        </div>
                    </Col>
                    <Col sm="12" md="3">
                        <Input
                            name="time"
                            label={t('SalesNewView.time')}
                            value={editSales.time}
                            disabled={true}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className="text-right d-flex align-items-center justify-content-end"
                    >
                        {editSales?.myDataError !== "" && editSales?.myDataError !== undefined && (
                            <Button className="view-sales-buttons" disabled={editSales.myDataStatus === "sent"}
                                    onClick={() => setShowMyDataErrorModal(true)}>{t('SalesNewView.myDataErrors')}</Button>
                        )}
                        <Modal backdrop={"static"} className="themeModal" show={showMyDataErrorModal}>
                            <Modal.Header>
                                <Modal.Title>Warning!</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>The document failed to be sent to MyData! <br/> The Error
                                is: <br/> {editSales?.myDataError}</Modal.Body>
                            <Modal.Footer>
                                <Button variant="outline-primary"
                                        onClick={() => setShowMyDataErrorModal(false)}>OK</Button>
                            </Modal.Footer>
                        </Modal>

                        <Button className="view-sales-buttons"
                                disabled={editSales.myDataStatus === "sent" || loadingSendToMyData
                                    || isEmpty(editSales?.myDataType) || (String(editSales?.myDataDestination) === "provider" && !isEmpty(editSales?.cancellationMark))}
                                onClick={() => sendToMyData()}>
                            {loadingSendToMyData && (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            )}
                            {t('SalesNewView.sendToMyData')}</Button>

                        {printLayout === "sales-print-a5-greek" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="sale"
                                       documentId={editSales._id} pdf={componentRefA5.current}/>)}
                        {printLayout === "sales-print-a5-english" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="sale"
                                       documentId={editSales._id} pdf={componentRefA5En.current}/>)}
                        {printLayout === "sales-print-a5-double-greek" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="sale"
                                       documentId={editSales._id} pdf={componentRefDA5.current}/>)}
                        {printLayout === "sales-print-a5-double-english" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="sale"
                                       documentId={editSales._id} pdf={componentRefDA5En.current}/>)}
                        {printLayout === "thermal-print-55mm" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="thermal"
                                       documentId={editSales._id} pdf={componentRefT50.current}/>)}
                        {printLayout === "thermal-print-80mm" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="thermal"
                                       documentId={editSales._id} pdf={componentRefT80.current}/>)}
                        {printLayout === "thermal-print-110mm" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="thermal"
                                       documentId={editSales._id} pdf={componentRefT110.current}/>)}
                        {(printLayout === "sales-print-template1-greek" || !printLayout) && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="sale"
                                       documentId={editSales._id} pdf={componentRef.current}/>)}
                        {printLayout === "sales-print-template1-english" && (
                            <SendEmail className="view-sales-buttons" clientId={editSales.client}
                                       modalContent="Do you want to send invoice mail to the client?"
                                       mailTo={editSales.email} mailSubject="Your Invoice"
                                       mailContent="Here is your invoice" documentType="sale"
                                       documentId={editSales._id} pdf={componentRefEn.current}/>)}
                    </Col>
                </Row>
                <Row className="disabled-page">
                    <Col sm="12" md="3">
                        <div className="mb-2">
                            <Input
                                className="mb-2 w-100"
                                label={t('SalesNewView.installation')}
                                name="installation"
                                value={getDefaultOptionByValue(dtInstallationsOptions, editSales.installation, 'value', 'label', 'value')?.label}
                                disabled={notEditableFields}
                            />
                        </div>
                    </Col>
                    <Col sm="12" md="3">
                        <div className="mb-2">
                            <Input
                                className="mb-2 w-100"
                                label={t('SalesNewView.preNumber.preNumber')}
                                name="preNumber"
                                value={editSales.preNumber !== "noprefix" ? editSales.preNumber : "Κενή"}
                                disabled={notEditableFields}
                            />
                        </div>
                    </Col>
                    <Col sm="12" md="3">
                        <div className="d-flex">
                            <Input
                                className="mb-2 w-100"
                                label={t('SalesNewView.number.number')}
                                name="number"
                                value={editSales.number.replace(editSales.preNumber, '')}
                                disabled={notEditableFields}
                            />
                        </div>
                    </Col>
                </Row>
                {(editSales.corelatedDocumentName) && (
                    <Row className="disabled-page">
                        <Col sm="12" md="4">
                            <div className="d-flex">
                                <Input
                                    className="mb-2 w-100"
                                    label={t('SalesNewView.corelatedConvertDocument')}
                                    name="number"
                                    value={editSales.corelatedDocumentName}
                                    disabled={notEditableFields}
                                />
                            </div>
                        </Col>
                    </Row>
                )}
                {(editSales?.correlatedDclName) && (
                    <Row className="disabled-page align-items-center">
                        <Col sm="12" md="6">
                            <div className="d-flex">
                                <Input
                                    className="mb-2 w-100"
                                    label={"Συσχετιζόμενη Εγγραφή Ψηφιακού Πελατολογίου"}
                                    name="correlatedDclName"
                                    value={editSales.correlatedDclName}
                                    disabled={notEditableFields}
                                />
                            </div>
                        </Col>
                        <Col md={2}>
                            <Button style={{padding: "10px", marginTop: "15px", pointerEvents: "auto"}} variant="primary"
                                    onClick={() => openCorrelatedDcl()}>
                                Εμφάνιση Εγγραφής
                            </Button>
                        </Col>
                    </Row>
                )}
                {(editSales?.sourceQuotation) && (
                    <Row className="disabled-page align-items-center">
                        <Col sm="12" md="6">
                            <div className="d-flex">
                                <Input
                                    className="mb-2 w-100"
                                    label={"Συσχετιζόμενη Προσφορά"}
                                    name="sourceQuotationName"
                                    value={editSales.sourceQuotationName || `Προσφορά #${editSales.sourceQuotation}`}
                                    disabled={notEditableFields}
                                />
                            </div>
                        </Col>
                        <Col md={2}>
                            <Button
                                style={{padding: "10px", marginTop: "15px", pointerEvents: "auto"}}
                                variant="primary"
                                onClick={() => openQuotation(dispatch, TABS_DATA, company.id, editSales.sourceQuotation)}
                            >
                                Εμφάνιση Προσφοράς
                            </Button>
                        </Col>
                    </Row>
                )}
                <Row>
                    {editSales.clientType === 'Existing' &&
                        <Col sm="30" md="6">
                            <div className="mb-2">
                                <Input
                                    className="w-100"
                                    label={t('SalesNewView.client.client')}
                                    name="clientName"
                                    value={editSales.clientName}
                                    disabled={notEditableFields}
                                />
                            </div>
                            {ACTIVITY.saveSales && editSales.clientType === 'New' && editSales.newClient === "" &&
                                <div className="text-danger">{t('SalesNewView.client.required')}</div>}
                            {ACTIVITY.saveSales && editSales.clientType === 'Existing' && editSales.client === "" &&
                                <div className="text-danger">{t('SalesNewView.client.required')}</div>}
                        </Col>
                    }
                    {editSales.clientType === 'New' &&
                        <Col sm="30" md="5">
                            <div className="mb-2">
                                <Input
                                    className="w-100 newclient-field"
                                    label={t('SalesNewView.newRetailClient.newRetailClient')}
                                    name="newClient"
                                    value={editSales.newClient}
                                    disabled={notEditableFields}
                                    placeholder="Add new retail client name"
                                />
                            </div>
                        </Col>
                    }
                    {(editSales.clientType === 'Existing' && isEmpty(editSales.amka)) && (
                        <Col sm="12" md="2">
                            <div className="d-flex">
                                <Input
                                    className="w-100"
                                    label={t('SalesNewView.clientInstallation.clientInstallation')}
                                    name="clientInstallation"
                                    value={editSales.clientInstallationType}
                                    disabled={notEditableFields}
                                />
                            </div>
                        </Col>
                    )}
                    {(editSales.clientType === 'Existing' && !isEmpty(editSales.amka)) && (
                        <Col sm="12" md="2" className={"mb-2"}>
                            <Input
                                className="w-100"
                                label={"ΑΜΚΑ Ασθενή"}
                                name="amka"
                                autoComplete={"off"}
                                value={editSales.amka}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {editSales.clientType === 'Existing' &&
                        <Col sm="12" md="2">
                            <div className="mb-2">
                                <Input
                                    className="w-100"
                                    label={t('SalesNewView.vat')}
                                    name="vat"
                                    value={editSales.vat}
                                    disabled={true}
                                    readonly
                                />
                            </div>
                        </Col>
                    }
                    {editSales.clientType === 'Existing' &&
                        <Col sm="12" md="2">
                            <Input
                                className="w-100"
                                label={t('SalesNewView.doy')}
                                name="doy"
                                value={DoyOptions.find((el) => String(el.value) === editSales.doy)?.label || editSales.doy}
                                disabled={notEditableFields}
                                readonly
                            />
                        </Col>
                    }
                    {/* Show if new client */}
                    {editSales.clientType === 'New' &&
                        <Col sm="12" md="2">
                            <div className="mb-2 ">
                                <Input
                                    className="w-100"
                                    label={t('SalesNewView.email.email')}
                                    name="email"
                                    required={editSales.clientType === 'New' && editSales.phone === ''}
                                    value={editSales.email}
                                    disabled={notEditableFields}
                                />
                                {ACTIVITY.saveSales && editSales.clientType === 'New' && editSales.email === "" && editSales.phone === "" &&
                                    <div className="text-danger">{t('SalesNewView.email.required')}</div>}
                            </div>
                        </Col>
                    }
                    {/* Show if new client */}
                    {editSales.clientType === 'New' &&
                        <Col sm="12" md="2">
                            <div className="mb-2 ">
                                <Input
                                    className="w-100"
                                    label={t('SalesNewView.phone.phone')}
                                    name="phone"
                                    required={editSales.clientType === 'New' && editSales.email === ''}
                                    disabled={notEditableFields}
                                    value={editSales.phone}
                                />
                            </div>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('SalesNewView.city')}
                            name="city"
                            value={editSales.city}
                            disabled={notEditableFields}
                            readonly
                        />
                    </Col>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('SalesNewView.address')}
                            name="address"
                            value={editSales.address}
                            disabled={notEditableFields}
                        />
                    </Col>
                    <Col sm="12" md="2" className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t("General.postalCode")}
                            name="pc"
                            value={editSales.pc}
                            disabled={notEditableFields}
                            readonly
                        />
                    </Col>
                    <Col md={6} className={"mb-2"}>
                        <Input
                            className="w-100"
                            label={t('General.activity')}
                            name="activity"
                            value={editSales.activity}
                            disabled={editSales.clientType !== 'New'}
                            readonly
                        />
                    </Col>
                </Row>

                <Row className="disabled-page">
                    <Col sm="12" md="4">
                        <Input
                            className="mb-2 w-100"
                            label={t('SalesNewView.paymentType.paymentType')}
                            name="paymentType"
                            value={editSales?.paymentTypeName}
                            disabled={notEditableFields}
                        />
                    </Col>
                    {!hidePosBankField &&
                        <Col sm="12" md="4">
                            <Input
                                className="mb-2 w-100"
                                label={t('SalesNewView.posBankAccount')}
                                name="bankAccount"
                                value={getLabelByValue(bankOptions, editSales?.bankAccount, 'value')}
                                disabled={notEditableFields}
                            />
                        </Col>
                    }
                    <Col sm="12" md="4">
                        <Input
                            className="mb-2 w-100"
                            label={t('SalesNewView.salePurpose')}
                            name="salePurpose"
                            value={getDefaultOptionByValue(salesPurposeOptions, editSales.salePurpose, 'value', 'label', 'value')?.label}
                            disabled={notEditableFields}
                        />
                    </Col>
                    {editSales.salePurpose === "19" && (
                        <Col md={4} className={"mb-3"}>
                            <Input
                                name={"salePurposeName"}
                                label={"Περιγραφή σκοπού διακίνησης"}
                                required={true}
                                autoComplete={"off"}
                                value={editSales.salePurposeName ? editSales.salePurposeName : ""}
                                disabled={true}
                            />
                        </Col>
                    )}
                </Row>
                {(editSales?.myDataType === "1.1" || editSales?.myDataType === "2.1" || editSales?.myDataType === "5.1" || editSales?.myDataType === "5.2")
                    && SETTINGS.settings.advancedTypesSales.find((doc) => doc._id === editSales.documentType)?.mydataProvider === "active"
                    && editSales?.enablePeppol === "active"
                    && (
                        <Row className={"mb-2"}>
                            <Col md={3} style={{pointerEvents: "none"}}>
                                <BetterCheckBox
                                    name={"enablePeppol"}
                                    text={"Αφορά δημόσια σύμβαση"}
                                    className={"mt-1 mb-1"}
                                    checked={editSales?.enablePeppol === "active"}
                                    disabled={true}
                                />
                            </Col>
                            {(editSales?.enablePeppol === "active") && (
                                <Col md={12}>
                                    <div style={{borderRadius: "5px", border: "1px solid #ecf0f5", padding: "10px"}}>
                                        <Row>
                                            {editSales?.myDataType !== "5.1" && (
                                                <Col md={3}>
                                                    <Input
                                                        name={"projectReference"}
                                                        label={"Α.Δ.Α. ή Ενάριθμος (BT-11)"}
                                                        value={editSales?.peppol?.projectReference ? editSales.peppol.projectReference : ""}
                                                        disabled={!viewSalePeppolEdit || loadingPeppolRequest}
                                                        required={true}
                                                        onChange={(e) => handleOnPeppolChange(e, "input", "projectReference")}
                                                    />
                                                </Col>
                                            )}
                                            <Col md={3}>
                                                {viewSalePeppolEdit ? (
                                                    <Row>
                                                        <Col md={10}>
                                                            <Input
                                                                name={"partyIdentification"}
                                                                label={"Κωδικός Αναθέτουσας Αρχής"}
                                                                value={editSales?.peppol?.partyIdentification ? editSales.peppol.partyIdentification : ""}
                                                                required={true}
                                                                disabled={true}
                                                            />
                                                        </Col>
                                                        <Col md={2}>
                                                            <SelectAnathetousaModal
                                                                data={editSales}
                                                                selectFunction={(obj) => handleOnPeppolChange(null, "anathetousaModal", obj)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                ) : (
                                                    <Input
                                                        name={"partyIdentification"}
                                                        label={"Κωδικός Αναθέτουσας Αρχής (BT-46)"}
                                                        value={editSales?.peppol?.partyIdentification ? editSales.peppol.partyIdentification : ""}
                                                        required={true}
                                                        disabled={true}
                                                    />
                                                )}
                                            </Col>
                                            <Col md={3}>
                                                <Input
                                                    name={"contractDocumentReference"}
                                                    label={"Α.Δ.Α.Μ. (BT-12)"}
                                                    value={editSales?.peppol?.contractDocumentReference ? editSales.peppol.contractDocumentReference : ""}
                                                    disabled={!viewSalePeppolEdit || loadingPeppolRequest}
                                                    onChange={(e) => handleOnPeppolChange(e, "input", "contractDocumentReference")}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                <DateBox
                                                    name={"dueDate"}
                                                    label={"Ημερομηνία"}
                                                    selected={moment(editSales?.peppol?.dueDate, "YYYY-MM-DD").isValid() ? moment(editSales?.peppol?.dueDate, "YYYY-MM-DD").toDate() : ""}
                                                    //disabled={!viewSalePeppolEdit || loadingPeppolRequest}
                                                    disabled={true}
                                                    onChange={(e) => handleOnPeppolChange(e, "datebox", "dueDate")}
                                                />
                                            </Col>
                                            <Col md={1}
                                                 style={{textAlign: "center", marginTop: "15px", fontWeight: "600"}}>
                                                {editSales?.peppol?.status === "waiting" && (
                                                    <div>Κατάσταση: <span style={{color: "orange"}}>Εκκρεμεί απάντηση από το ΚΕ.Δ.</span>
                                                    </div>
                                                )}
                                                {editSales?.peppol?.status === "error" && (
                                                    <Popover placement={"leftTop"} content={
                                                        <div>
                                                            {editSales?.peppol.statusReason &&
                                                                <span>Status Reason: {editSales?.peppol.statusReason}</span>}
                                                            <hr style={{margin: "2px"}}/>
                                                            {editSales?.peppol.statusReasonCode &&
                                                                <span>Status Reason Code: {editSales?.peppol.statusReasonCode}</span>}
                                                            {editSales?.peppol.errorIdentification &&
                                                                <span> <br/> Identification: {editSales?.peppol.errorIdentification}</span>}
                                                            <hr style={{margin: "2px"}}/>
                                                            {editSales?.peppol.responseCode &&
                                                                <span>Response Code: {editSales?.peppol.responseCode}</span>}

                                                        </div>
                                                    } title={<div style={{textAlign: "center"}}>Προβολή
                                                        Σφάλματος</div>}>
                                                        <div>Κατάσταση: <span style={{color: "red"}}>Σφάλμα</span></div>
                                                    </Popover>
                                                )}
                                                {editSales?.peppol?.status === "sent" && (
                                                    <div>Κατάσταση: <span style={{color: "green"}}>Εστάλη</span></div>
                                                )}
                                                {(editSales?.peppol?.responseHistory?.length > 0) && (
                                                    <Badge bg={"primary"} onClick={() => setShowPeppolHistory(true)}
                                                           style={{cursor: "pointer"}}>Ιστορικό</Badge>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={3}>
                                                <Input
                                                    name={"paymentMethodInfo"}
                                                    label={"Όροι πληρωμής (ΒΤ-20)"}
                                                    placeholder={"Προσθέστε όρους πληρωμής"}
                                                    value={editSales?.peppol?.paymentMethodInfo ? editSales.peppol.paymentMethodInfo : ""}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <Input
                                                    name={"buyerReference"}
                                                    label={"Στοιχείο Αναφοράς Αγοραστή (ΒΤ-10)"}
                                                    placeholder={"Προσθέστε στοιχείο αναφοράς αγοραστή"}
                                                    value={editSales?.peppol?.buyerReference ? editSales.peppol.buyerReference : ""}
                                                    disabled={!viewSalePeppolEdit || loadingPeppolRequest}
                                                    onChange={(e) => handleOnPeppolChange(e, "input", "buyerReference")}
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <Input
                                                    name={"purchaseOrderReference"}
                                                    label={"Αναφορά Εντολής Αγοράς (BT-13)"}
                                                    placeholder={"Προσθέστε αναφορά εντολή αγοράς"}
                                                    value={editSales?.peppol?.purchaseOrderReference ? editSales.peppol.purchaseOrderReference : ""}
                                                    disabled={!viewSalePeppolEdit || loadingPeppolRequest}
                                                    onChange={(e) => handleOnPeppolChange(e, "input", "purchaseOrderReference")}
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <Input
                                                    name={"salesOrderReference"}
                                                    label={"Στοιχείο αναφοράς εντολής πώλησης (BT-14)"}
                                                    placeholder={"Προσθέστε στοιχείο αναφοράς εντολής πώλησης"}
                                                    value={editSales?.peppol?.salesOrderReference ? editSales.peppol.salesOrderReference : ""}
                                                    disabled={true}
                                                    onChange={(e) => handleOnPeppolChange(e, "input", "salesOrderReference")}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={"mt-2"}>
                                            {!viewSalePeppolEdit && (
                                                <Col md={12}>
                                                    <Button size={"sm"} className={"mr-1"}
                                                            onClick={() => enablePeppolEdit()}>Τροποποίηση</Button>
                                                    <Button size={"sm"} style={{float: "right"}}
                                                            onClick={() => getPeppolStatus(true, true)} disabled={loadingPeppolStatus}>Ανανέωση
                                                        κατάστασης {loadingPeppolStatus && (<Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>)}</Button>
                                                    <Button size={"sm"} style={{float: "right"}} className={"mr-1"}
                                                            onClick={() => handleCheckPeppolFields()}
                                                            disabled={loadingCheckPeppolFields}>Έλεγχος εγκυρότητας
                                                        πεδίων {loadingCheckPeppolFields &&
                                                            <Spinner className={"ml-2"} animation="border"
                                                                     variant="dark"/>}</Button>
                                                </Col>
                                            )}
                                            {viewSalePeppolEdit && (
                                                <Col md={12}>
                                                    <Button size={"sm"} className={"mr-2"}
                                                            onClick={() => savePeppolEdit()}
                                                            disabled={loadingPeppolRequest}>
                                                        Αποθήκευση & επαναποστολή
                                                        {loadingPeppolRequest &&
                                                            <Spinner className={"ml-2"} animation="border"
                                                                     variant="dark"/>}
                                                    </Button>
                                                    <Button size={"sm"} onClick={() => cancelPeppolEdit()}
                                                            disabled={loadingPeppolRequest}>Ακύρωση</Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    )}
                <Row>
                    <Col md="12" className="mb-2">
                        <ul className="react-tabs__tab-list tab-style tab-min component-subtabs">
                            {(() => {
                                const tabs = [...editSalesTab];
                                if (isDeliveryNoteTypes.includes(editSales?.myDataType) || ["9.1", "9.2", "9.3"].includes(editSales?.myDataType)) {
                                    tabs.push(editCorrelatedEntitiesTab);
                                    tabs.push(packingsDeclarationsTab);
                                }
                                if (canHaveOtherCorrelations && editSales?.otherCorrelatedInvoices?.length > 0) tabs.push(otherCorrelatedInvoicesTab);

                                return tabs.map((tab, i) => (
                                    <li key={i} className="react-tabs__tab">
                                        <button type="button" onClick={() => setActiveTab(i)}
                                                className={`customNavBtn ${activeTab === i && "btnActive"}`}>
                                            <span className="textWrapper">{tab.tabName}</span>
                                        </button>
                                    </li>
                                ));
                            })()}
                        </ul>
                        {(() => {
                            const tabs = [...editSalesTab];
                            if (isDeliveryNoteTypes.includes(editSales?.myDataType) || ["9.1", "9.2", "9.3"].includes(editSales?.myDataType)) {
                                tabs.push(editCorrelatedEntitiesTab);
                                tabs.push(packingsDeclarationsTab);
                            }
                            if (canHaveOtherCorrelations && editSales?.otherCorrelatedInvoices?.length > 0) tabs.push(otherCorrelatedInvoicesTab);

                            return <div className="innerTabPanel">{tabs[activeTab]?.tabData}</div>;
                        })()}
                    </Col>
                </Row>

                <Row className="disabled-page">
                    <Col sm="12" md="8">
                        <EditableTable
                            className="sales-taxes-calculations"
                            allowActions={false}
                            key={"sales-taxes-calculations"}
                            data={fixDocumentTaxesDisplay(editSales, "sales")}
                            columns={salesTaxesColumns}
                            actionButtons={{
                                print: false,
                                delete: false,
                                export: false,
                                edit: false,
                            }}
                        />
                    </Col>
                    <Col sm="12" md="4" className="d-flex justify-content-end">
                        <span className="mr-3 fw-bold">{t('SalesNewView.totalsTable.title')}</span>
                        <table className="table table-bordered mb-2">
                            <tbody>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalQuantity')}</td>
                                <td>{totalQuantity}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalBeforeDiscount')}</td>
                                <td>{getGreekCurrencyFormat(totalBeforeDiscount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalDiscount')}</td>
                                <td>{getGreekCurrencyFormat(totalDiscount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalNetValue')}</td>
                                <td>{getGreekCurrencyFormat(totalNetValue)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalVatAmount')}</td>
                                <td>{getGreekCurrencyFormat(totalVatAmount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalWithHoldTaxesAmount')}</td>
                                <td>{getGreekCurrencyFormat(withHoldTaxes)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalTaxesAmount')}</td>
                                <td>{getGreekCurrencyFormat(totalTaxes)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNewView.totalsTable.totalAmount')}</td>
                                <td>{getGreekCurrencyFormat(totalAmount)}</td>
                            </tr>
                            {(editSales?.transactionDetails?.tipAmountString) && (
                                <tr>
                                    <td className="fw-bold">Φιλοδώρημα</td>
                                    <td>{getGreekCurrencyFormat(Number(String(editSales?.transactionDetails?.tipAmountString).replaceAll(",", ".")))}</td>
                                </tr>
                            )}
                            <tr>
                                <td className="fw-bold">{t('SalesNew.totalsTable.paymentAmount')}</td>
                                {(!isEmpty(editSales?.transactionDetails?.tipAmountString) ? (
                                    <td>{getGreekCurrencyFormat((Number(paymentAmount) + Number(String(editSales?.transactionDetails?.tipAmountString).replaceAll(",", "."))).toFixed(2))}</td>
                                ) : (
                                    <td>{getGreekCurrencyFormat(paymentAmount)}</td>
                                ))}
                            </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>

                <Row className="disabled-page">
                    <div style={{width: "100%"}}>
                        <div className="text-muted"><i>{t('SalesNewView.salesNotes')}</i></div>
                        <Alert variant={"secondary mt-1 mb-1"} style={{userSelect: "auto"}}>
                            <div
                                dangerouslySetInnerHTML={{__html: String(editSales.notes).replace(/\n/g, "<br/>")}}></div>
                        </Alert>
                    </div>
                </Row>

                {[...isDeliveryNoteTypes, "9.1", "9.2", "9.3"].includes(editSales.myDataType) && (
                    <Row className={"mt-3"}>
                        <div className="text-muted mb-2"><i>Επιλογές Διακίνησης</i></div>
                        <Col md={4}>
                            <BetterCheckBox
                                name={"nonObligatedRecipient"}
                                text={"Μη Υπόχρεος Λήπτης"}
                                checked={editSales?.nonObligatedRecipient}
                                disabled={true}
                            />
                        </Col>
                        <Col md={4}>
                            <BetterCheckBox
                                name={"withoutDigitalTransportTracking"}
                                text={"Χωρίς ψηφιακή παρακολούθηση διακίνησης"}
                                checked={editSales?.withoutDigitalTransportTracking}
                                disabled={true}
                            />
                        </Col>
                    </Row>
                )}
                {editSales?.enablePeppol === "active" && (
                    <Modal backdrop={"static"} show={showPeppolHistory} onHide={() => setShowPeppolHistory(false)}
                           dialogClassName={"modal40PercentWidth"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Ιστορικό Απαντήσεων από το Κ.Ε.Δ.</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {editSales?.peppol?.responseHistory?.length > 0 ? (
                                <table style={{
                                    tableLayout: "fixed",
                                    width: "100%",
                                    textAlign: "center",
                                    border: "1px solid gray"
                                }}>
                                    <thead>
                                    <tr>
                                        <th style={{border: "1px solid gray"}}>Status Reason</th>
                                        <th style={{border: "1px solid gray"}}>Status Reason Code</th>
                                        <th style={{border: "1px solid gray"}}>Ημερομηνία</th>
                                        <th style={{border: "1px solid gray"}}>Response Code</th>
                                        <th style={{border: "1px solid gray"}}>Απάντηση</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {editSales?.peppol?.responseHistory.map((row, idx) => (
                                        <tr key={`peppolHistory${idx}`}>
                                            <td style={{border: "1px solid gray"}}>{row["statusReason"]}</td>
                                            <td style={{border: "1px solid gray"}}>{row["statusReasonCode"]}</td>
                                            <td style={{border: "1px solid gray"}}>{isEmpty(row["responseTimestamp"]) ? String(row["effectiveDate"]).substring(0, 10) : row["responseTimestamp"]}</td>
                                            <td style={{border: "1px solid gray"}}>{row["responseCode"]}</td>
                                            <td style={{border: "1px solid gray"}}>{getGreekPeppolResponseFromCode(row["responseCode"])}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            ) : (
                                <>Δεν βρέθηκε ιστορικό.</>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowPeppolHistory(false)}>
                                Κλείσιμο
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>

            <SalesPrintA5Greek ref={componentRefA5} data={printTemplateData}/>
            <SalesPrintA5English ref={componentRefA5En} data={printTemplateData}/>
            <SalesPrintA5DoubleGreek ref={componentRefDA5} data={printTemplateData}/>
            <SalesPrintA5DoubleEnglish ref={componentRefDA5En} data={printTemplateData}/>
            <SalesPrintTemplateGreek1 ref={componentRef} data={printTemplateData}/>
            <SalesPrintTemplateEnglish1 ref={componentRefEn} data={printTemplateData}/>
            <ThermalPrint55 ref={componentRefT50} data={printTemplateData}/>
            <ThermalPrint80 ref={componentRefT80} data={printTemplateData}/>
            <ThermalPrint110 ref={componentRefT110} data={printTemplateData}/>
        </div>
    )
}

export const SalesEditLog = ({tabKey = "0"}) => {
    const {t} = useTranslation();
    const editSales = useSelector((state) => state.SALES.editSales[tabKey]);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.saleLog')}</i></div>
            <LogTable itemId={editSales._id}/>
        </React.Fragment>
    )
}

export default ViewSales;
